<script setup>
const props = defineProps({
  sale: {
    type: Object,
    required: true
  }
})

</script>

<template>
  <div class="relative rounded-xl">
    <div class="overflow-hidden rounded-2xl">
      <div>
        <div class="self-stretch flex-grow">
          <div class="aspect-1">
            <img
              :src="sale.auction.pic.image"
              :alt="sale.auction.title ?? '.'"
              class="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        </div>

        <div class="absolute inset-0 flex flex-col justify-end text-left px-4 pb-4 z-20">
          <div class="text-white py-2 px-4 font-bold">
            <span class="text-sm">{{ sale.auction.title }}</span>
          </div>
        </div>
      </div>

      <div class="absolute overflow-hidden rounded-2xl inset-0 bg-gradient-to-b from-transparent to-black opacity-75"></div>
    </div>

    <div class="absolute rounded-2xl overflow-hidden inset-0 flex items-center justify-center bg-opacity-25 bg-white">
      <div class="text-center text-white bg-black bg-opacity-50 rounded-full text-sm px-2 py-1">
        {{ __('Preview Only') }}
      </div>
    </div>
  </div>
</template>

